import { get } from './requests';

const downloadFile = async (path: string, filename: string) => {
  const response = await get(path, true);
  const blob = await response.blob();

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;

  document.body.appendChild(a);
  a.click();
  a.remove();
};

export default downloadFile;
